import React from "react";
import { useTranslation } from "react-i18next";
import anpc from "../../assets/img/anpc.png";
import SOL from "../../assets/img/SOL.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer id="footer" className="footer dark-background">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <h3 className="sitename">Zapibook</h3>
            <p>{t("footer.description")}</p>
            <div className="footer-links">
              <Link to="/terms-and-conditions">{t("footer.terms")}</Link>
              <Link to="/privacy-policy">{t("footer.privacy")}</Link>
            </div>
            <div className="SOL d-flex align-items-center gap-2 mt-3">
              <a
                href="https://anpc.ro/ce-este-sal/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={anpc} alt="ANPC" className="anpc" />
              </a>
              <a
                href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={SOL} alt="SOL" className="sol" />
              </a>
            </div>
          </div>

          <div className="footer-right">
            <div className="social-links d-flex justify-content-end mb-3">
              <a href="#">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
            <div className="text-end mt-4">
              <div className="copyright">
                <span>©</span>{" "}
                <strong className="px-1 sitename">Zapibook</strong>{" "}
                <span>2025</span>
              </div>
              <div className="credits">{t("footer.rights_reserved")}</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
